import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  deleteConfigTemplate,
  listConfigTemplates,
  registerConfigTemplate,
  updateConfigTemplate,
} from './api/api'
import { configTemplatesListKey } from './keyFactory'
import type { ConfigTemplate } from './types'

export function useConfigTemplates() {
  return useQuery({
    queryKey: configTemplatesListKey(),
    queryFn: listConfigTemplates,
  })
}

// All mutations invalidate the list (plan.md §3.4 — no hand-rolled cache edits).
function useInvalidatingMutation<TArgs>(mutationFn: (args: TArgs) => Promise<ConfigTemplate>) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: configTemplatesListKey() })
    },
  })
}

export function useRegisterConfigTemplate() {
  return useInvalidatingMutation((template: ConfigTemplate) => registerConfigTemplate(template))
}

export function useUpdateConfigTemplate() {
  return useInvalidatingMutation((template: ConfigTemplate) => updateConfigTemplate(template))
}

export function useDeleteConfigTemplate() {
  return useInvalidatingMutation((id: string) => deleteConfigTemplate(id))
}
